// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap JS (optional, for components like modals, tooltips, etc.)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store/store';
import './assets/global.scss';

createApp(App)
  .use(store)
  .use(router)
  .mount('#app');
